import { useEffect } from "react";
import { useDispatch } from "react-redux";
import {
  asyncActionError,
  asyncActionFinish,
  asyncActionStart,
} from "../async/asyncReducer";
import {
  dataFromSnapshot,
  logErrorInFirestore,
} from "../firestore/firestoreService";
import { onSnapshot } from "@firebase/firestore";

export default function useFirestoreCollection({
  query,
  data,
  deps,
  shouldExecute = true,
  queryCode = 0,
  isErrorOut = true,
}) {
  const dispatch = useDispatch();
  useEffect(() => {
    if (!shouldExecute) return;
    dispatch(asyncActionStart(queryCode));
    const unsubscribe = onSnapshot(
      query(),
      (snapshot) => {
        const docs = snapshot.docs.map((doc) => dataFromSnapshot(doc));
        data(docs);
        dispatch(asyncActionFinish());
      },
      async (error) => {
        if (isErrorOut) {
          dispatch(asyncActionError(error.message));
        }
        await logErrorInFirestore({
          error: error.message,
          firestoreListener: true,
          notes: {
            query: query.toString(),
            queryCode: queryCode,
            errorFull: error.toString(),
          },
        });
      }
    );
    return () => {
      unsubscribe();
    };
  }, deps); // eslint-disable-line react-hooks/exhaustive-deps
}
